"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.4,24a.41.41,0,0,0,.18-.05l9.1-5.51-9.1,5.51A.41.41,0,0,1,14.4,24Z",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.57,23.33V12.74h0V23.33a.67.67,0,0,0,.34.58.62.62,0,0,0,.32.09h0a.62.62,0,0,1-.32-.09A.67.67,0,0,1,13.57,23.33Z",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "23.68 17.24 16.26 12.74 16.26 12.74 23.68 17.24",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1.65",
    y: "15.27",
    width: "5.04",
    height: "4.95",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1.61",
    y: "1.58",
    width: "5.04",
    height: "4.95",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "15.54",
    y: "1.58",
    width: "5.04",
    height: "4.95",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.26,0H0V8.11H8.26ZM6.65,6.53h-5V1.58h5Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.19,0H13.93V8.11h8.26ZM20.58,6.53h-5V1.58h5Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0,21.8H8.26V13.69H0Zm1.65-6.53h5v4.95h-5Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "10.13",
    width: "1.93",
    height: "8.11",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "22.19 12.74 22.19 10.91 16.14 10.91 19.16 12.74 22.19 12.74",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.57,10.91H7v1.83h5V12.3A2.19,2.19,0,0,1,12.57,10.91Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.57,12.3a.67.67,0,0,1,.34-.58.63.63,0,0,1,.33-.09h0a.62.62,0,0,0-.32.09.67.67,0,0,0-.34.58v.44h0Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "14.57 11.72 14.57 11.72 16.26 12.74 16.26 12.74 14.57 11.72 14.57 11.72",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    y: "9.09",
    width: "3.91",
    height: "1.83",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "10.62",
    y: "15.46",
    width: "1.43",
    height: "1.83",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.68,17.24l-7.42-4.5-1.68-1h0a.66.66,0,0,0-.33-.09.63.63,0,0,0-.33.09.67.67,0,0,0-.34.58v11a.67.67,0,0,0,.34.58.62.62,0,0,0,.32.09.47.47,0,0,0,.17,0,.48.48,0,0,0,.18-.08l9.1-5.51a.68.68,0,0,0,0-1.15Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.24,11.63a.66.66,0,0,1,.33.09A.66.66,0,0,0,14.24,11.63Z",
    style: {
      fill: '#ff'
    }
  }));
};

exports["default"] = _default;